/**
 * Fetches a game's CSV export.
 *
 * Uses raw fetch because the endpoint returns text/csv.
 * The generated client can't handle CSV responses (tries to parse as JSON).
 * Token is pulled from the cache (no MSAL dependency).
 */

import { supabaseClient } from "@/config/supabase";
import { getTokenAsync, getTokenSync } from "@/utils/token-cache";

export async function fetchGameCsv(gameId: string): Promise<string> {
  // Try fast sync path first, fall back to async
  const token = getTokenSync() ?? (await getTokenAsync(supabaseClient));

  if (!token) {
    throw new Error("No authentication token available");
  }

  const response = await fetch(
    `${import.meta.env.VITE_API_BASE_URL_SPO}/game/${gameId}/csv?untagged=1`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  if (!response.ok) {
    throw new Error("Failed to download CSV");
  }

  return response.text();
}
